import React from "react";

import HeaderWrapper from "../common/HeaderWrapper";

import ActivityList from "./ActivityList";

const ActivityPage = () => (
  <React.Fragment>
    <HeaderWrapper breadcrumbs={[{ label: "Activity" }]} />
    <div className="content-wrapper">
      <ActivityList />
    </div>
  </React.Fragment>
);

export default ActivityPage;
